/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    clearCategory: {
        id: 'quoteandbind.RiskAssistDwellings.templates.Occupation.clearCategory',
        defaultMessage: 'Clear Category'
    },
    industryCodeSearch: {
        id: 'quoteandbind.RiskAssistDwellings.templates.Occupation.Operation Esthetic Code Search',
        defaultMessage: 'Operation Esthetic Code Search'
    },
    Code: {
        id: 'quoteandbind.RiskAssistDwellings.templates.Occupation.Code',
        defaultMessage: 'Code'
    },
    search: {
        id: 'quoteandbind.RiskAssistDwellings.templates.Occupation.Search',
        defaultMessage: 'Search'
    },
    reset: {
        id: 'quoteandbind.RiskAssistDwellings.templates.Occupation.Reset',
        defaultMessage: 'Reset'
    },
    cancel: {
        id: 'quoteandbind.RiskAssistDwellings.templates.Occupation.Cancel',
        defaultMessage: 'Cancel'
    },
    searchResults: {
        id: 'quoteandbind.RiskAssistDwellings.templates.Occupation.Search Results',
        defaultMessage: 'Search Results'
    },
    select: {
        id: 'quoteandbind.RiskAssistDwellings.templates.Occupation.Select',
        defaultMessage: 'Select'
    },
    industryCode: {
        id: 'quoteandbind.RiskAssistDwellings.templates.Occupation.Operations Code',
        defaultMessage: 'Operations Code'
    },
    descriptionOfOccupancy: {
        id: 'quoteandbind.RiskAssistDwellings.templates.Occupation.Description Of Occupancy',
        defaultMessage: 'Description Of Occupancy'
    }
});